import { useCallback, useEffect, useMemo, useState, type ReactNode } from 'react';
import { enModeDemo } from '@/shared/supabase/client';
import { serviceAuthDemo } from './auth.demo';
import { serviceAuthSupabase } from './auth.supabase';
import { ContexteAuth } from './contexte';
import type { EtatSession, ServiceAuth } from './types';

function serviceParDefaut(): ServiceAuth {
  return enModeDemo() ? serviceAuthDemo : serviceAuthSupabase;
}

export function AuthProvider({
  children,
  service = serviceParDefaut(),
}: {
  children: ReactNode;
  service?: ServiceAuth;
}) {
  const [etat, setEtat] = useState<EtatSession>({ statut: 'chargement' });

  useEffect(() => {
    let actif = true;
    void service.lireSession().then((initial) => {
      if (actif) setEtat(initial);
    });
    const desabonner = service.surChangement((suivant) => {
      if (actif) setEtat(suivant);
    });
    return () => {
      actif = false;
      desabonner();
    };
  }, [service]);

  const relire = useCallback(() => {
    void service.lireSession().then(setEtat);
  }, [service]);

  const valeur = useMemo(() => ({ etat, service, relire }), [etat, service, relire]);
  return <ContexteAuth.Provider value={valeur}>{children}</ContexteAuth.Provider>;
}
